__turbopack_context__.v({
  "add-on-text": "poxOKW_add-on-text",
  "additionals-delimiter": "poxOKW_additionals-delimiter",
  "checkbox-card": "poxOKW_checkbox-card",
  "error-message": "poxOKW_error-message",
  "form": "poxOKW_form",
});
